// @flow
import React, { useContext, useEffect, useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import isEmpty from 'ramda/es/isEmpty';
import length from 'ramda/es/length';
import prop from 'ramda/es/prop';
import { useDispatch } from 'react-redux';

import { commaJoin } from 'app/common/lib/address';
import { ReceiverItem } from 'app/common/components/Shop';
import { OptionProps, OptionProp } from 'app/common/ui-next/option-props';
// $FlowFixMe
import { studentFetch } from 'app/actions/users/students';
import { popupErr } from 'app/common/actions/popup';
import { getFIO } from 'app/common/lib/names';

import { OrderContext } from '../../OrderData';
import styles from './AdminOrderFooter.module.scss';;


const emptyObj = {};

const OrderFooter = () => {
  const { t } = useTranslation('shop');
  const dispatch = useDispatch();

  const {
    content: { order, receivers },
    loading: { order: loadingOrder },
    request,
  } = useContext(OrderContext);

  const {
    postal_code: postalCode,
    state_name: stateName,
    name,
    city,
    street,
    comment,
    delivery_point: deliveryPoint = emptyObj,
  } = order;

  const address = useMemo(() => commaJoin(
    postalCode,
    stateName,
    city,
    street,
    prop('name', deliveryPoint),
  ), [
    postalCode,
    stateName,
    city,
    street,
    deliveryPoint,
  ]);

  // запрос получателей с идентификаторами кабинета
  useEffect(() => {
    if (!loadingOrder) {
      request.receivers();
    }
  }, [loadingOrder]); // eslint-disable-line react-hooks/exhaustive-deps

  const handleRequestStudent = useCallback(async (id: number) => {
    if ((process.env.APP_NAME || process.env.REACT_APP_NAME) !== 'journal') {
      const errorText = 'Не предусмотрена функция запроса ученика для этого кабинета';
      dispatch(popupErr(errorText));
      throw new Error(errorText);
    }

    const res = await dispatch(studentFetch(id));
    const { klass = '', name: name_ } = prop(String(id), res) || {};

    return ({
      id,
      classTitle: klass,
      name: getFIO(name_),
    });
  }, [dispatch]);

  return (
    <div className={styles.root}>
      <OptionProps className={styles.column}>

        {name
          && <OptionProp title={t('customer')}>
            {name}
          </OptionProp>}

        {receivers
          && !isEmpty(receivers)
          && <OptionProp title={length(receivers) > 1 ? t('recipients') : t('recipient')}>
            {receivers.map(({ name: recipient, id, type }) => (
              <div key={id}>
                <ReceiverItem
                  key={id}
                  id={id}
                  type={type}
                  name={recipient}
                  onStudentRequest={handleRequestStudent}
                />
              </div>
            ))}
          </OptionProp>}

      </OptionProps>
      <OptionProps className={styles.column}>

        {address
          && <OptionProp title={t('delivery_address')}>
            {address}
          </OptionProp>}

        {comment
          && <OptionProp title={t('comment')}>
            {comment}
          </OptionProp>}

      </OptionProps>
    </div>
  );
};

export default OrderFooter;
